<template>
  <div class="build-team">
    <el-page-header @back="$router.go(-1)" content="团队组建"> </el-page-header>

    <el-tabs v-model="activeName" type="card" style="margin-top: 20px">
      <el-tab-pane label="测评问卷" name="1" lazy>
        <Questionnaire />
      </el-tab-pane>
      <el-tab-pane label="岗位分配" name="2" v-if="isCaptain">
        <Postassignment ref="postassignment" />
      </el-tab-pane>
      <el-tab-pane label="定岗" name="3">
        <PostInfo ref="postInfo" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Questionnaire from "./questionnaire.vue";
import Postassignment from "./postassignment.vue";
import { myTeam } from "@/api/team";
import PostInfo from "./postInfo.vue";
export default {
  components: { Postassignment, Questionnaire, PostInfo },
  data() {
    return {
      activeName: "1",
      isCaptain: Boolean,
    };
  },
  created() {
    this.getMyTeam();
  },
  watch: {
    activeName(val) {
      if (val == "2") this.$refs.postassignment.getList();
      else if (val == "3") this.$refs.postInfo.getMemberList();
    },
  },
  methods: {
    // 我的团队
    getMyTeam() {
      myTeam({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.isCaptain = res.data.isCaptain;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.build-team {
  padding: 20px 33px;
  background-color: #ffffff;
}
</style>